/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55546404
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from '@components/@core/Pagination';
import { length } from '~/services/util';
import Edit from './Edit';
import Detail from './Detail';
import Document from './List';

class List extends Component {
    handleMenuChange(document, e) {
        const selectedMenu = e[0].value;
        if (selectedMenu === 'Assign') {
            this.props.onModal({
                type: 'Assign Document',
                data: { before: { documents: [] }, after: [] },
            });
        } else if (selectedMenu === 'Delete') {
            this.props.onModal({
                type: 'Confirm',
                data: {
                    before: {
                        title: 'Delete',
                        body: 'Are you sure you want to delete this document?',
                    },
                },
                callBack: {
                    onYes: () => this.props.onDelete(document.id),
                },
            });
        } else {
            this.props.onToggle(selectedMenu, document.id);
        }
    }

    render() {
        const { isAdmin, iconName, documentName, data, perPage, current, total, onChange, onPer, onShow, onToggle } = this.props;

        return (
            <div className="library-document-card px-0">
                {data.map((document, index) => (
                    <Document
                        key={`document${index}`}
                        isAdmin={isAdmin}
                        name={document.name || document.title}
                        description={document.data.description}
                        iconName={iconName}
                        documentName={documentName}
                        modules={length(document.children)}
                        updated={document.updated_at}
                        attachments={document.data.attachment ? document.data.attachment : document.data.image}
                        onToggle={() => onToggle('Detail View', document.id)}
                        onChange={(e) => this.handleMenuChange(document, e)}
                        onShow={() => onShow(document)}
                    />
                ))}
                <Pagination perPage={perPage} current={current} total={total} onChange={onChange} onPer={onPer} />
            </div>
        );
    }
}

List.propTypes = {
    data: PropTypes.array,
    onToggle: PropTypes.func,
};

List.defaultProps = {
    data: [],
    onToggle: () => {},
};

export { List, Detail, Edit };
